<template>
    <div>
        <div
                v-bind:style="stylePosition"
                class="job"
                :class="{isWorkerOwner:job.isWorkerOwner}">
            <div class="vertically-centered" @click="jobSelected = job">
                {{ job.zip }}
            </div>
        </div>
        <div>
            <DiscloseJob v-bind:job="jobSelected" v-if="job.isWorkerOwner !== true"
                         v-on:closeModal="jobSelected=null">
            </DiscloseJob>
        </div>
    </div>
</template>

<script>
    import DiscloseJob from "./DiscloseJob";
	export default {
		components: {DiscloseJob},
		props: {
            job: Object,
            firstDisplayedHour: Number,
            lastDisplayedHour: Number,
        },
        data(){
			return{
		        jobSelected : null
            }
        },
        methods:{
			closeModal(){
				this.jobSelected=null;
            }
        },
        computed: {
            stylePosition() {
                return {
                    left: 100*(this.job.startsAtTimeslotIndex/3 - this.firstDisplayedHour)/this.numberOfDisplayedHours + '%',
                    width: 100*this.job.durationInHours/this.numberOfDisplayedHours + '%',
                };
            },
            numberOfDisplayedHours() {
                return this.lastDisplayedHour - this.firstDisplayedHour + 1;
            },
        }
    }
</script>

<style scoped>
    .job {
        position: absolute;
        background-color: #a2be3d;
        text-align: center;
        font-weight: bold;
        color: white;
        font-size: 10px;
        top: 40px;
        height: 20px;
        display: flex;
        z-index: 333;
        /*opacity: 0.9;*/
    }
    .vertically-centered {
        margin: auto;
        text-align: center;
        position: relative;
        z-index: 99999;
    }
    .isWorkerOwner{
        background-color: gray;
    }
</style>
